export const LOCATION_PERMISSION = {
    perm1: 'core_admin_locations',
    perm2: 'core_admin_location_add',
    perm3: 'core_admin_location_detail',
    perm4: 'core_admin_location_edit',
    perm5: 'core_admin_location_delete',
    perm6: 'core_admin_location_move',
    perm7: 'core_admin_location_import',
};
